import React from "react";

function Contact() {
  return (
    <>
      <h2 className="mt-32 text-6xl text-center">Contact us.</h2>
    </>
  );
}

export default Contact;
